import { Theme } from "@mui/material";

export const Variants = (theme: Theme) => {
  return {
    None: {},
    TermsHighlight: {
      '.MuiPaper-root': {
        width: '36.375rem',
        gap: '1rem',
        border: `0.25rem solid ${theme.colors["orange.500"]}`,
        maxHeight: 'fit-content',
      },

      '.modal-header > span': {
        color: theme.colors['orange.500']
      },
      '.modal-body': {
        fontSize: theme.fontSizes.lg,
        'ul': {
          display: 'flex',
          flexDirection: 'column',
          gap: '1.25rem',
          listStyle: 'none',
          
          "@media (max-width: 600px)": {
            paddingLeft: "15px",
          },
        },
        'li': {
          paddingLeft: '1.25rem'
        },
        'li > span': {
          color: theme.colors['neutral.50'],
          fontWeight: theme.fontWeights.medium,
        },
        'li::marker': {
          content: '"►"',
          color: theme.colors['pink.400']
        }
      },
    },
    AccessibilityRequirementsChange: {
      '.MuiPaper-root': {
        width: '36.375rem',
        gap: '1rem',
        border: `0.25rem solid ${theme.colors["orange.500"]}`,
        maxHeight: 'fit-content',
      },

      '.modal-header > span': {
        color: theme.colors['orange.500']
      },
      '.modal-body': {
        fontSize: theme.fontSizes.lg,
        'ul': {
          display: 'flex',
          flexDirection: 'column',
          gap: '1.25rem',
          listStyle: 'none',
          
          "@media (max-width: 600px)": {
            paddingLeft: "15px",
          },
        },
        'li': {
          paddingLeft: '1.25rem'
        },
        'li > span': {
          color: theme.colors['neutral.50'],
          fontWeight: theme.fontWeights.medium,
        },
        'li::marker': {
          content: '"►"',
          color: theme.colors['pink.400']
        }
      },
    },
    AllocationAccessibilityRequirementsAdded: {
      '.MuiPaper-root': {
        width: '36.375rem',
        gap: '1rem',
        border: `0.25rem solid ${theme.colors["orange.500"]}`,
        maxHeight: 'fit-content',
      },

      '.modal-header > span': {
        color: theme.colors['orange.500']
      },
      '.modal-body': {
        fontSize: theme.fontSizes.lg,
        'ul': {
          display: 'flex',
          flexDirection: 'column',
          gap: '1.25rem',
          listStyle: 'none',
          
          "@media (max-width: 600px)": {
            paddingLeft: "15px",
          },
        },
        'li': {
          paddingLeft: '1.25rem'
        },
        'li > span': {
          color: theme.colors['neutral.50'],
          fontWeight: theme.fontWeights.medium,
        },
        'li::marker': {
          content: '"►"',
          color: theme.colors['pink.400']
        }
      },
    },
    AllocationAccessibilityRequirementsRemoved: {
      '.MuiPaper-root': {
        width: '36.375rem',
        gap: '1rem',
        border: `0.25rem solid ${theme.colors["orange.500"]}`,
        maxHeight: 'fit-content',
      },

      '.modal-header > span': {
        color: theme.colors['orange.500']
      },
      '.modal-body': {
        fontSize: theme.fontSizes.lg,
        'ul': {
          display: 'flex',
          flexDirection: 'column',
          gap: '1.25rem',
          listStyle: 'none',
          
          "@media (max-width: 600px)": {
            paddingLeft: "15px",
          },
        },
        'li': {
          paddingLeft: '1.25rem'
        },
        'li > span': {
          color: theme.colors['neutral.50'],
          fontWeight: theme.fontWeights.medium,
        },
        'li::marker': {
          content: '"►"',
          color: theme.colors['pink.400']
        }
      },
    },
    AllocationUpdatedAge: {
      '.MuiPaper-root': {
        width: '36.375rem',
        gap: '1rem',
        border: `0.25rem solid ${theme.colors["orange.500"]}`,
        maxHeight: 'fit-content',
      },

      '.modal-header > span': {
        color: theme.colors['orange.500']
      },
      '.modal-body': {
        fontSize: theme.fontSizes.lg,
        'ul': {
          display: 'flex',
          flexDirection: 'column',
          gap: '1.25rem',
          listStyle: 'none',
          
          "@media (max-width: 600px)": {
            paddingLeft: "15px",
          },
        },
        'li': {
          paddingLeft: '1.25rem'
        },
        'li > span': {
          color: theme.colors['neutral.50'],
          fontWeight: theme.fontWeights.medium,
        },
        'li::marker': {
          content: '"►"',
          color: theme.colors['pink.400']
        }
      },
    },
    DeleteAccount: {
      '.MuiPaper-root':{
        gap: '2rem',
        width: '36.375rem',
        height: '18.313rem',
      },
      '.modal-content-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      '.modal-body': {
        fontSize: theme.fontSizes.md,
        textAlign: 'center',
      },    
    },
    DeactivateAccount: {
      '.MuiPaper-root':{
        gap: '2rem',
        width: '36.375rem',
        maxHeight: 'fit-content'
      },
      '.modal-body': {
        alignSelf: 'stretch',
        lineHeight: theme.space._500,
      },
      '.modal-button-container': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        gap: '1.5rem'
      }
    },
    ReactivateAccount: {
      '.MuiPaper-root':{
        gap: '2rem',
        width: "36.375rem",
        maxHeight: 'fit-content'
      },
      '.modal-content-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '.modal-body': {
        alignSelf: 'stretch',
        lineHeight: theme.space._500,
      },
      '.modal-button-container': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        gap: '1.5rem'
      }
  
    },
    ResetPassword: {
      '.MuiPaper-root':{
        alignItems: 'center',
        gap: '2rem',
        width: "36.375rem",
        maxHeight: 'fit-content'
      },
      '.modal-body': {
        fontSize: theme.fontSizes.lg,
      },
      '.modal-button-container': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
        alignSelf: 'stretch',

        '& span': {
          display: 'flex',
          gap: '0.25rem',
        }
      }
    },
    EditGuestDetails: {
      '.MuiPaper-root':{
        gap: '2rem',
        width: "36.375rem",
        maxHeight: 'fit-content',
        height: 'inherit'
      },
      '.modal-content-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '.modal-body': {
        alignSelf: 'stretch',
        lineHeight: theme.space._500,
      },
      '.modal-button-container': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        gap: '1.5rem'
      }
    },
    RemoveTickets: {
      '.MuiPaper-root':{
        gap: '2rem',
        maxHeight: 'fit-content'
      },
      '.modal-content-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '.modal-body': {
        alignSelf: 'stretch',
        lineHeight: theme.space._500,
      },
      '.modal-button-container': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'stretch',
        gap: '1.5rem'
      }
    },
    AcceptTicket: {
      '.MuiPaper-root':{
        gap: '2rem',
        width: '36.375rem',
        height: 'fit-content',
      },
      '.modal-content-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      '.modal-body': {
        fontSize: theme.fontSizes.md,
        textAlign: 'center',
      },    
    },
    DeclineTicket: {
      '.MuiPaper-root':{
        gap: '2rem',
        width: '36.375rem',
        height: '18.313rem',
      },
      '.modal-content-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      '.modal-body': {
        fontSize: theme.fontSizes.md,
        textAlign: 'center',
      },    
    },
    NonPrioritySessionSelected: {
      '.MuiPaper-root':{
        gap: '2rem',
        width: '36.375rem',
        height: 'fit-content',
      },
      '.modal-content-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      '.modal-body': {
        fontSize: theme.fontSizes.md,
        textAlign: 'center',
      },    
    },
    PriorityTicketsFullyBooked: {
      '.MuiPaper-root':{
        gap: '2rem',
        width: '36.375rem',
        height: 'fit-content',
      },
      '.modal-content-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      '.modal-body': {
        fontSize: theme.fontSizes.md,
        textAlign: 'center',
      },    
      ".MuiDialogActions-root.modal-button-container": {
        justifyContent: "center",
      },
    },
    NotEnoughPriorityTickets: {
      '.MuiPaper-root':{
        gap: '2rem',
        width: '36.375rem',
        height: 'fit-content',
      },
      '.modal-content-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      '.modal-body': {
        fontSize: theme.fontSizes.md,
        textAlign: 'center',
      },    
      ".MuiDialogActions-root.modal-button-container": {
        justifyContent: "center",
      },
    },
    SaveProgress: {
      '.MuiPaper-root':{
        gap: '2rem',
        width: '42rem',
        height: '18.313rem',
      },
      '.modal-content-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      '.modal-body': {
        fontSize: theme.fontSizes.md,
        textAlign: 'center',
      }
    }
  }
}
